import { render, staticRenderFns } from "./birthday-message-settings.vue?vue&type=template&id=866c6bd0&scoped=true&"
import script from "./birthday-message-settings.vue?vue&type=script&lang=js&"
export * from "./birthday-message-settings.vue?vue&type=script&lang=js&"
import style0 from "./birthday-message-settings.vue?vue&type=style&index=0&id=866c6bd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866c6bd0",
  null
  
)

export default component.exports